import { useMutation } from '@apollo/client';
import { showToast } from 'components/common/CustomToast';
import { CREATE_FEEDBACK } from 'graphql/mutations/createFeedback';
import {
  CreateFeedbackInput,
  Mutation,
  MutationCreateFeedbackArgs,
} from 'types/generatedSchemaTypes';

const useCreateFeedback = () => {
  const [createFeedbackMutation, { loading }] = useMutation<
    Mutation,
    MutationCreateFeedbackArgs
  >(CREATE_FEEDBACK, {
    onError: () => {
      showToast('error.feedbacksendFailed', 'error');
    },
  });

  const createFeedback = async (
    feedBack: CreateFeedbackInput,
    setFeedbackSubmitted: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    const feedbackComponents = feedBack.feedbackComponents;
    const intent = feedBack.intent;
    const metaData = feedBack.metaData;
    const transactionId = feedBack.transactionId;
    await createFeedbackMutation({
      variables: {
        input: {
          feedbackComponents,
          intent,
          metaData,
          transactionId,
          feedbackSubmittedAt: new Date().toISOString(),
        },
      },
      onCompleted: () => {
        setFeedbackSubmitted(true);
      },
    });
  };

  return { createFeedback, loading };
};

export default useCreateFeedback;
